export const BRAND_NAME = 'Velisim'
export const BRAND_MARK = '/assets/images/velisim-mark.png'
export const BRAND_LOGO = '/assets/images/velisim-logo.jpg'
export const BRAND_FAVICON = '/assets/images/velisim-mark.png'

/** Velisim blue scale from the brand color guide. */
export const BRAND_COLORS = {
  25: '#F0F8FF',
  50: '#E2F1FF',
  100: '#B9DBFF',
  200: '#8AC5FF',
  300: '#58AEFF',
  400: '#2E9CFF',
  500: '#008CFF',
  600: '#027DF1',
  700: '#0F6BDD',
  800: '#0048D4',
  900: '#173AAB',
  1000: '#013260',
}

export function displayBrandName(name) {
  const value = String(name || '').trim()
  if (!value || /rex\s*vpn/i.test(value) || /simvox/i.test(value)) return BRAND_NAME
  return value
}
